<template>
  <div>
    <Modal
      id="create-order-by-partner"
      no-stacking>
      <template v-slot:modal-title>
        <span class="modal-title">Выберите партнера</span>
      </template>
      <template v-slot:default>
        <div class="grid-y space-y-2 p-8">
          <div class="cell">
            <Select :options="options" :label="'name'"
                    :placeholder="'Выберите партнера'"
                    :value="partner"
                    @input="($event) => partner = $event" />
          </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <div class="flex space-x-2">
          <button
            class="btn btn-xs btn-outline-primary flex-grow"
            @click="$bvModal.hide('create-order-by-partner')">Отмена</button>
          <button
            class="btn btn-xs btn-primary flex-grow"
            :disabled="!partner"
            @click="submit()">Создать заказ</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { mapActions, mapState } from 'vuex';
import Select from '@/components/Select.vue';

export default {
  components: {
    Modal,
    Select,
  },
  props: {
    object: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      partner: null,
    };
  },
  computed: {
    ...mapState({
      list: (state) => state.partners.partners,
    }),
    partners() {
      return this.list ?? [];
    },
    options() {
      return this.partners;
    },
    formUrl() {
      return `${process.env.VUE_APP_PARTNER_BASE_URL.replace(/\/$/, '')}/?partnerId=${this.partner?.uuid}`;
    },
  },
  methods: {
    ...mapActions({
      fetch: 'partners/ACT_FETCH_PARTNERS',
    }),
    submit() {
      if (!this.object) {
        return;
      }
      const normalizeSpaces = (str) => str.replace(/\s+/g, ' ');
      const person = this.object.burials?.[0]?.persons?.[0];
      const payload = {
        customerPhone: this.object.customer?.phone ?? '',
        customerFio: normalizeSpaces(this.object.customer?.name) ?? '',
        customerEmail: this.object.customer?.email ?? '',
        burialSection: this.object.section ?? '',
        burialNumber: this.object.crypt ?? '',
      };
      if (this.object.cemetery) {
        payload.cemetery = {
          value: this.object.cemetery.id,
          label: this.object.cemetery.name,
        };
        if (this.object.cemetery.district) {
          payload.district = {
            value: this.object.cemetery.district.id,
            label: this.object.cemetery.district.name,
          };
          if (this.object.cemetery.district.region) {
            payload.region = {
              value: this.object.cemetery.district.region.id,
              label: this.object.cemetery.district.region.name,
            };
          }
        }
      }
      if (person) {
        if (person.birthday) {
          payload.departedBirthday = person.birthday;
        }
        if (person.deathday) {
          payload.departedDeathday = person.deathday;
        }
        const namePartials = normalizeSpaces(person.name).split(' ');
        if (namePartials[0]) {
          // eslint-disable-next-line prefer-destructuring
          payload.departedLastName = namePartials[0];
        }
        if (namePartials[1]) {
          // eslint-disable-next-line prefer-destructuring
          payload.departedFirstName = namePartials[1];
        }
        if (namePartials[2]) {
          // eslint-disable-next-line prefer-destructuring
          payload.departedPatronymic = namePartials[2];
        }
      }
      const target = `${this.formUrl}&prefill=${window.btoa(encodeURIComponent(JSON.stringify(payload)))}`;
      window.open(target);
    },
  },
  mounted() {
    this.fetch();
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::hidden');
  },
};
</script>
